"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayMeasurmentAsPercent = exports.isSampleSolid = exports.areAllValuesPass = exports.determinePanelPassFail = exports.resultsMapFactory = exports.shouldDisplayPassFail = exports.isAcidicCannabinoid = exports.getWaterActivity = exports.getDensity = exports.getMoistureContent = exports.upperCaseFail = exports.fail = exports.upperCasePass = exports.pass = exports.defaultBuildRows = exports.buildRows = exports.defaultGetAnalyteValue = exports.createRowObjects = exports.filterParamters = exports.getParameters = exports.findStateRegulationByReferenceComponentId = exports.findStateRegulation = exports.removeUndisplayedRows = exports.findAnalyteResults = exports.convertFromDisplayUnits = exports.convertToDisplayUnits = void 0;
var math = __importStar(require("mathjs"));
var R = __importStar(require("ramda"));
var calculations_1 = require("./calculations");
var isNaN_1 = __importDefault(require("lodash/isNaN"));
var convertToDisplayUnits = function (units) { return units.replace("u", "µ"); };
exports.convertToDisplayUnits = convertToDisplayUnits;
var convertFromDisplayUnits = function (units) {
    return units.replace("µ", "u");
};
exports.convertFromDisplayUnits = convertFromDisplayUnits;
var findAnalyteResults = function (_a) {
    var rawName = _a.rawName, _b = _a.analyteProp, analyteProp = _b === void 0 ? "name" : _b;
    return R.find(R.propEq(analyteProp, rawName));
};
exports.findAnalyteResults = findAnalyteResults;
exports.removeUndisplayedRows = R.filter(R.propEq("displayOnCOA", true));
var findStateRegulation = function (path) { return function (value) {
    return R.find(R.pathEq(path, value));
}; };
exports.findStateRegulation = findStateRegulation;
exports.findStateRegulationByReferenceComponentId = exports.findStateRegulation([
    "referenceComponent",
    "id",
]);
exports.getParameters = R.prop("parameters");
var filterParamters = function (data) {
    return R.assoc("parameters", R.compose(exports.removeUndisplayedRows, exports.getParameters)(data), data);
};
exports.filterParamters = filterParamters;
var createRowObjects = function (data) {
    return R.pipe(exports.getParameters, R.map(function (parameter) { return ({
        parameter: parameter,
        stateRegulation: exports.findStateRegulationByReferenceComponentId(parameter.referenceComponent.id)(data.stateRegulations),
        results: data.results,
        moistureContentPercentage: data.moistureContentPercentage,
        density: data.density,
        isSolid: data.isSolid,
    }); }))(data);
};
exports.createRowObjects = createRowObjects;
var defaultGetAnalyteValue = function (row) { var _a; return (_a = exports.findAnalyteResults({ rawName: row.parameter.referenceComponent.rawName })(row.results.components)) === null || _a === void 0 ? void 0 : _a.final_amount; };
exports.defaultGetAnalyteValue = defaultGetAnalyteValue;
var buildRows = function (determineResultFunction) {
    if (determineResultFunction === void 0) { determineResultFunction = exports.defaultGetAnalyteValue; }
    return R.pipe(exports.filterParamters, exports.createRowObjects, R.sortWith([R.descend(determineResultFunction)]));
};
exports.buildRows = buildRows;
exports.defaultBuildRows = exports.buildRows();
var pass = function () { return R.identity("Pass"); };
exports.pass = pass;
var upperCasePass = function () { return R.toUpper(exports.pass()); };
exports.upperCasePass = upperCasePass;
var fail = function () { return R.identity("Fail"); };
exports.fail = fail;
var upperCaseFail = function () { return R.toUpper(exports.fail()); };
exports.upperCaseFail = upperCaseFail;
var getMoistureContent = function (sample) { var _a, _b; return (_b = (_a = sample.panelResults.find(function (_a) {
    var panel = _a.panel;
    return panel.name === "Moisture Content";
})) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.moistureContent; };
exports.getMoistureContent = getMoistureContent;
var getDensity = function (sample) { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = sample.panelResults
    .find(function (_a) {
    var panel = _a.panel;
    return panel.name === "Density";
})) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.find(function (component) { return component.name === "density"; })) === null || _d === void 0 ? void 0 : _d.final_amount) !== null && _e !== void 0 ? _e : 1; };
exports.getDensity = getDensity;
var getWaterActivity = function (sample) { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = sample.panelResults.find(function (_a) {
    var panel = _a.panel;
    return panel.name === "Water Activity";
})) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.final_amount) !== null && _e !== void 0 ? _e : "NT"; };
exports.getWaterActivity = getWaterActivity;
var isAcidicCannabinoid = function (cannabinoidName) {
    return cannabinoidName.includes("A");
};
exports.isAcidicCannabinoid = isAcidicCannabinoid;
var shouldDisplayPassFail = function (sample) {
    console.log({
        reportTemplate: sample.reportTemplateOption.reportTemplate.name,
    });
    return sample.reportTemplateOption.reportTemplate.name === "Pass/Fail";
};
exports.shouldDisplayPassFail = shouldDisplayPassFail;
var findPanel = function (panelName) {
    return R.find(R.pathEq(["panel", "name"], panelName));
};
var findPanelResult = R.curry(function (panelName, sample) {
    return R.pipe(R.prop("panelResults"), findPanel(panelName))(sample);
});
var findCannabinoidsResult = findPanelResult("Cannabinoids");
var findTerpenesResult = findPanelResult("Terpenes");
var findHeavyMetalsResult = findPanelResult("Heavy Metals");
var findResidualSolventsResult = findPanelResult("Residual Solvents");
var findMicrobialResult = findPanelResult("Microbial");
var findChemicalResidueResult = findPanelResult("Chemical Residue");
var findForeignMaterialResult = findPanelResult("Foreign Material");
var findMositureContentResult = findPanelResult("Moisture Content");
var findWaterActivityResult = findPanelResult("Water Activity");
var resultsMapFactory = function (sample) { return ({
    cannabinoids: findCannabinoidsResult(sample),
    terpenes: findTerpenesResult(sample),
    heavyMetals: findHeavyMetalsResult(sample),
    residualSolvents: findResidualSolventsResult(sample),
    microbial: findMicrobialResult(sample),
    chemicalResidue: findChemicalResidueResult(sample),
    foreignMaterial: findForeignMaterialResult(sample),
    moistureContent: findMositureContentResult(sample),
    waterActivity: findWaterActivityResult(sample),
}); };
exports.resultsMapFactory = resultsMapFactory;
var mapActionLimitsToComponentValues = function (_a) {
    var panelResult = _a.panelResult, stateReportingRegulations = _a.stateReportingRegulations, _b = _a.analyteProp, analyteProp = _b === void 0 ? "name" : _b, density = _a.density, _c = _a.shouldCorrectForMoisture, shouldCorrectForMoisture = _c === void 0 ? false : _c, moistureContentPercentage = _a.moistureContentPercentage, _d = _a.filterComponentFunc, filterComponentFunc = _d === void 0 ? function () { return true; } : _d;
    return !!panelResult
        ? panelResult.results.components
            .filter(filterComponentFunc)
            .map(function (component) {
            var _a;
            return (__assign(__assign({ componentValue: calculations_1.correctForMoisture(calculations_1.correctForDensity(component.final_amount || 0, density), shouldCorrectForMoisture ? moistureContentPercentage : 0) }, stateReportingRegulations.find(function (regulation) {
                return regulation.referenceComponent.rawName === component[analyteProp];
            })), { lod: ((_a = panelResult.instrumentUsed.instrumentParameters.find(function (_a) {
                    var referenceComponent = _a.referenceComponent;
                    return referenceComponent.rawName === component[analyteProp];
                })) === null || _a === void 0 ? void 0 : _a.levelOfDetection) || 0 }));
        })
        : [];
};
var checkIfValueIsBelowActionLimit = function (_a) {
    var _b, _c;
    var componentValue = _a.componentValue, actionLimit = _a.actionLimit, actionLimitPerPackage = _a.actionLimitPerPackage, actionLimitPerServing = _a.actionLimitPerServing, amountPerPackage = _a.amountPerPackage, amountPerServing = _a.amountPerServing, lod = _a.lod;
    if (isNaN_1.default(componentValue))
        return true;
    if (componentValue < lod)
        return true;
    return ((R.isNil(actionLimit) || componentValue <= actionLimit) &&
        (R.isNil(actionLimitPerServing) ||
            componentValue * ((_b = amountPerServing === null || amountPerServing === void 0 ? void 0 : amountPerServing.value) !== null && _b !== void 0 ? _b : 0) <=
                actionLimitPerServing) &&
        (R.isNil(actionLimitPerPackage) ||
            componentValue * ((_c = amountPerPackage === null || amountPerPackage === void 0 ? void 0 : amountPerPackage.value) !== null && _c !== void 0 ? _c : 0) <= actionLimitPerPackage));
};
var areAllComponentsBelowActionLimit = R.all(checkIfValueIsBelowActionLimit);
var determinePanelPassFail = function (data) {
    return R.pipe(mapActionLimitsToComponentValues, areAllComponentsBelowActionLimit)(data)
        ? "PASS"
        : "FAIL";
};
exports.determinePanelPassFail = determinePanelPassFail;
var getPassFailValues = function (obj) {
    return R.values(obj);
};
exports.areAllValuesPass = R.compose(R.all(R.equals("PASS")), getPassFailValues);
var isSampleSolid = function (sample) {
    return sample.unitOfMeasure !== "mL" &&
        !sample.matrix.sampleCategory.name.match(/Volume/i);
};
exports.isSampleSolid = isSampleSolid;
var displayMeasurmentAsPercent = function (measurement, precision) {
    if (precision === void 0) { precision = 3; }
    return measurement > 0
        ? math.format(calculations_1.convertPpmToPercent(measurement), {
            precision: precision,
            notation: "fixed",
        }) + "%"
        : "ND";
};
exports.displayMeasurmentAsPercent = displayMeasurmentAsPercent;
//# sourceMappingURL=index.js.map